import React from 'react';
import ReactRouter from 'react-router';
import { Button } from '@ordermentum/ui-shared/atoms/Button';
import { Animation } from '@ordermentum/ui-shared/atoms/Animation';
import axios from 'axios';
import { safeRedirect } from '@ordermentum/ui-shared/helpers/urls';
import { RouteParams } from './Forms/index.types';
import { LoginBase } from './LoginBase';
import { Header } from './DefaultLogin';
import { PaymentSuccessBanner } from './Forms/index.styles';

export const PendingActivation = (
  props: ReactRouter.RouteComponentProps<RouteParams, {}>
) => {
  const [loading, setLoading] = React.useState(true);

  const { paymentRequestId: id, token } = props?.location?.query ?? {};

  if (!id) {
    window.location.href = '/dashboard';
  }

  React.useEffect(() => {
    axios
      .post(`/v1/payment-requests/${id}/add-user?`, { token })
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, []);

  return (
    <LoginBase type="default" header={<Header />} {...props}>
      {!loading && (
        <PaymentSuccessBanner>
          <Animation type="success-confetti" />
          <h1>Thanks!</h1>
          <p>You are all ready to get started.</p>

          <Button
            type="primary-submit"
            borderRadius="6"
            size="max"
            height="normal"
            onClick={() => {
              window.location.href = safeRedirect('/dashboard');
            }}
          >
            Continue to dashboard
          </Button>
        </PaymentSuccessBanner>
      )}
    </LoginBase>
  );
};
